import React from 'react';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import { useSelector } from 'react-redux';
import { DividerSection } from '../../../../../../global/components/layout/divider-section';
import { TcsmStates } from '../../../../../../root/tcsm-model';
import { NewHireProps } from '../../../../models/arc-epi-props';
import { useCompensationInfo } from '../../../compensation/compensation-history/useCompensation';
import { EmploymentState } from '../../../employment/employment-model';
import { useEmploymentInfo } from '../../../employment/useEmployment';
import { LabelAndValue } from '../../../../../../global/components/data-display/label-value';
import { getFormattedDate } from '../../../../../../global/helpers/date-helpers';
import { CompensationHistoryState } from '../../../compensation/compensation-history/compensation-history-model';


interface Props {
	settings: NewHireProps;

}
export function CoverageEmploymentCompensationReview(props: Props) {
	const { settings } = props;
	const employmentInfoLoad = useEmploymentInfo();
	const employmentState = useSelector<TcsmStates, EmploymentState>(state => state?.employmentState);
	const compensationState = useSelector<TcsmStates, CompensationHistoryState>(state => state?.compensationHistoryState);

	const compensationLoad = useCompensationInfo([employmentState?.currentEmployee?.employment_id], employmentState?.currentEmployee?.id);
	const stipEmployment = employmentState?.currentEmployment;
	const comp = compensationState?.allScheduledPayments[0];

	if (!employmentInfoLoad || !compensationLoad) {
		return <LoadingCircle />;
	}

	return (
		<>
			{
				stipEmployment &&
				<DividerSection sectionText={settings?.employmentCompensationHeader}>
					{stipEmployment?.current_position_title ? <p>{`${getFormattedDate(stipEmployment?.current_position_title_start_date)} - ${settings?.presentLabel}`}</p> : null}
					<h4>{settings?.employmentTitle}</h4> 
					<LabelAndValue label={settings?.institutionLabel} value={stipEmployment?.employer_name} />
					{stipEmployment?.current_position_title ? <LabelAndValue label={settings?.positionLabel} value={stipEmployment?.current_position_title} /> : null}
					<LabelAndValue label={settings?.addressLabel} value={`${stipEmployment?.employer_street_address}, ${stipEmployment?.employer_location}, ${stipEmployment?.employer_country}`} />
					<h4>{settings?.compensationTitle}</h4>
					<LabelAndValue label={settings?.baseSalaryLabel} value={comp?.cash_salary} />
					<LabelAndValue label={settings?.cashHousingAllowanceLabel} value={comp?.housing_cash_allowance} />
					<LabelAndValue label={settings?.employerProvidedHousingLabel} value={comp?.housing_provided} />
					<LabelAndValue label={settings?.dbHousingValueLabel} value={comp?.calculated_housing} />
					<LabelAndValue label={settings?.dcHousingValueLabel} value={comp?.calculated_housing_dc_rsvp} />
					<LabelAndValue label={settings?.dbCompTotalLabel} value={comp?.tac} />
					<LabelAndValue label={settings?.dcCompTotalLabel} value={comp?.tac_dc_rsvp} />

				</DividerSection>
			}

		</>
	);
}